module.exports = __webpack_public_path__ + "static/RGPDHome-70e061712a4862d0cf69553335e60f36.webp";